import React, { useEffect, useRef, useState } from 'react'
import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock'
import SimpleBar from 'simplebar-react'
import { getUniqueId } from 'common/utils/getUniqueId'
import { INTERACTIVE_BLOCKS, STATIC_BLOCKS } from '../../Blocks/BlockSettings'
import BLOCK from 'common/constants/BlockTypes/BlocksEnum'
import { useAssetManager } from 'components/AssetManager'

import PanelHeader from '../components/PanelHeader.jsx'
import TemplatesPanel from '../Templates/TemplatesPanel'

import i18n from '../../../../../../i18n'

const BLOCKS = [
    {
        label: i18n.t('Static'),
        blocks: STATIC_BLOCKS,
    },
    {
        label: i18n.t('Interactive'),
        blocks: INTERACTIVE_BLOCKS,
    },
]

const BlocksPanel = ({ open, onAdd, insertBeforeId, onClose }) => {
    const wrapperRef = useRef()
    const panelScrollRef = useRef()
    const { chooseAsset } = useAssetManager(true)

    const [templatesState, setTemplatesState] = useState({
        isOpen: false,
        selectedBlockMeta: null,
    })

    useEffect(() => {
        if (open) {
            disableBodyScroll(wrapperRef.current, { reserveScrollBarGap: true })
        } else {
            clearAllBodyScrollLocks()
        }
    }, [open])

    const showTemplates = async blockMeta => {
        setTemplatesState({
            isOpen: true,
            selectedBlockMeta: blockMeta,
        })
    }

    const chooseTemplate = async (blockMeta, blockStructure) => {
        const blockType = blockMeta.t
        if (blockType === BLOCK.image || blockType === BLOCK.logo) {
            const blockId = getUniqueId()
            chooseAsset(
                null,
                data => onAdd(blockType, insertBeforeId, { url: data.src, author: data.author }, blockId),
                blockId,
            )
        } else onAdd(blockType, insertBeforeId, blockStructure)

        setTemplatesState({
            isOpen: false,
            selectedBlockMeta: null,
        })
    }

    const chooseAction = async blockMeta => {
        if (blockMeta.hasTemplates) showTemplates(blockMeta)
        else chooseTemplate(blockMeta, {})
    }

    const onClosePanel = () => {
        setTemplatesState({
            isOpen: false,
            selectedBlockMeta: null,
        })
        onClose()
    }

    return (
        <>
            <div className={`editor-panel editor-panel--blocks${open ? ' is-opened' : ''}`} ref={wrapperRef}>
                <PanelHeader blockName={i18n.t('All blocks')} scrollRef={panelScrollRef} />
                <div className="close" onClick={onClosePanel} />
                <SimpleBar className="blocks-content" autoHide={false} scrollableNodeProps={{ ref: panelScrollRef }}>
                    <ul className="list">
                        {BLOCKS &&
                            BLOCKS.map((group, i) => {
                                const getStyles = block => {
                                    const styles = {}
                                    if (
                                        templatesState.isOpen &&
                                        templatesState.selectedBlockMeta &&
                                        templatesState.selectedBlockMeta.t === block.t
                                    ) {
                                        styles.borderColor = block.color
                                    }
                                    return styles
                                }

                                return (
                                    <li key={i}>
                                        {group.label && <p className="label">{group.label}</p>}
                                        {group.blocks.length ? (
                                            <ul className="inner-list">
                                                {group.blocks.map(blockMeta => {
                                                    return (
                                                        <li
                                                            key={blockMeta.t}
                                                            className={`${
                                                                blockMeta.iconActive
                                                                    ? ' editor-panel--blocks--has-active-icon'
                                                                    : ''
                                                            }${blockMeta.hasTemplates ? ' can-collapse' : ''}`}
                                                            style={getStyles(blockMeta)}
                                                            onClick={() => chooseAction(blockMeta)}
                                                            data-test={`choose-block-${blockMeta.t}`}
                                                        >
                                                            {blockMeta.icon ? (
                                                                <div className="img">
                                                                    <img src={blockMeta.icon} alt="icon" />
                                                                </div>
                                                            ) : null}
                                                            {blockMeta.iconActive ? (
                                                                <div className="img img--active">
                                                                    <img src={blockMeta.iconActive} alt="icon" />
                                                                </div>
                                                            ) : null}
                                                            <p>{blockMeta.label}</p>
                                                        </li>
                                                    )
                                                })}
                                            </ul>
                                        ) : null}
                                    </li>
                                )
                            })}
                    </ul>
                </SimpleBar>

                {open && templatesState.isOpen ? (
                    <TemplatesPanel
                        blockType={templatesState.selectedBlockMeta.t}
                        title={templatesState.selectedBlockMeta.templatesTitle}
                        onAdd={blockStruct => chooseTemplate(templatesState.selectedBlockMeta, blockStruct)}
                    />
                ) : null}
            </div>
            {open ? <div className="editor-panel-overlay" onClick={onClosePanel} /> : null}
        </>
    )
}

export default BlocksPanel
